import { LuPin, LuPinOff } from "react-icons/lu";
import {
  SideMenuBehavior,
  useSideMenuActions,
  useSideMenuBehavior,
} from "../../../view_stores/useSideMenuStore";

export default function SideMenuPinBtn() {
  const sideMenuBehavior = useSideMenuBehavior();
  const { switchBehavior } = useSideMenuActions();

  return (
    <div className="w-full flex justify-end">
      <button
        onClick={switchBehavior}
        className="py-[10px] pl-[14px] pr-[10px] rounded-s-full
          text-light-text dark:text-dark-text
        bg-[#C6C9D9] dark:bg-[#212528]
        hover:opacity-50 dark:hover:opacity-50
        transition-opacity duration-200"
      >
        {sideMenuBehavior === SideMenuBehavior.PINNED ? (
          <LuPinOff size={22} className="rotate-[30deg]" />
        ) : (
          <LuPin size={22} className="rotate-[30deg]" />
        )}
      </button>
    </div>
  );
}
